import { FormControlLabel, Radio, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useMenu } from "react-instantsearch-core"

import { sendFilterChangedEvent } from "@/utils/posthog"

import FilterSection, { CountBadge } from "./components/FilterSection"

const UPHOLSTERY_VALUES = ["true", "false"]

export default function UpholsteryFilter() {
  const { t } = useTranslation("items")
  const { items, refine, canRefine } = useMenu({
    attribute: "has_upholstery",
    limit: 2,
  })

  const upholsteryItems = UPHOLSTERY_VALUES.flatMap((value) => {
    const item = items.find((candidate) => candidate.value === value)
    return item ? [item] : []
  })
  const activeCount = upholsteryItems.some((item) => item.isRefined) ? 1 : 0

  if (!canRefine && activeCount === 0) {
    return null
  }

  return (
    <FilterSection title={t("has_upholstery")} activeCount={activeCount} trackingKey="upholstery">
      <Stack sx={{ gap: 0.5 }}>
        {upholsteryItems.map((item) => {
          const isUpholstered = item.value === "true"
          const label = isUpholstered ? t("Yes") : t("No")
          const handleRefine = () => {
            sendFilterChangedEvent({
              filterGroup: "upholstery",
              filterKey: item.value,
              filterLabel: label,
              isActive: !item.isRefined,
              value: isUpholstered,
              metadata: {
                result_count: item.count,
              },
            })
            refine(item.value)
          }

          return (
            <FormControlLabel
              key={item.value}
              control={
                <Radio
                  checked={item.isRefined}
                  onChange={handleRefine}
                  onClick={(event) => {
                    if (item.isRefined) {
                      event.preventDefault()
                      handleRefine()
                    }
                  }}
                  size="small"
                  sx={{ padding: 0.5 }}
                />
              }
              label={
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography sx={{ flexGrow: 1, fontSize: "0.875rem" }}>{label}</Typography>
                  <CountBadge value={item.count} />
                </Stack>
              }
              sx={{
                marginRight: 0,
                marginLeft: "-5px",
                "& .MuiFormControlLabel-label": {
                  width: "100%",
                },
              }}
            />
          )
        })}
      </Stack>
    </FilterSection>
  )
}
